import { defineComponent as t, openBlock as r, createBlock as c, unref as a, mergeProps as d, withCtx as p, createElementVNode as n } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const h = /* @__PURE__ */ t({
  name: "IconReassuranceShield12Months",
  __name: "IconReassuranceShield12Months",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const l = o;
    return (i, e) => (r(), c(a(s), d(l, { "view-box": "0 0 48 48" }), {
      default: p(() => [...e[0] || (e[0] = [
        n("path", {
          "fill-rule": "evenodd",
          d: "M38 24.65c0 8.02-8.19 12.9-14 15.35-6.7-2.82-14-7.65-14-15.35V8h28v16.65m-6.68-7.35c0-1.87-1.52-3.2-3.82-3.2-2.56 0-3.96 1.39-3.97 3.76h2.29c0-1.31.71-2 1.71-2a1.45 1.45 0 0 1 1.59 1.46A3 3 0 0 1 28 19.43l-4.34 4.11v1.86h7.74v-1.92h-4.75l2.82-2.74a4.93 4.93 0 0 0 1.85-3.44m-12.38-3.05L16.49 16v2.28l2.38-1.67v8.79h2.21V14.25h-2.14",
          "clip-rule": "evenodd"
        }, null, -1),
        n("path", {
          "fill-rule": "evenodd",
          d: "M2 24.35V0h44v24.35C46 36.45 35.15 44.12 24 48 12.81 44.05 2 36.45 2 24.35m22 19.39c6.31-2.39 18-8.39 18-19.39V4H6v20.35c0 4.74 2.38 13.45 18 19.39",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  h as default
};
